module.exports = __webpack_public_path__ + "static/media/custom-music-player.2241ba33.png";